import { Fragment } from "react";
import { Grid } from "@mui/material";

import { TextField } from "../../../components";

export default function AudienceSizeForm({ campaign, formikProps, component }) {
  return (
    <Fragment>
      <Grid size={12} style={{ marginTop: "10px" }}>
        <TextField
          label={"Final Audience Parameters"}
          disabled={component === "consumer"}
          minRows={5}
          formikProps={formikProps}
          name="audience_params"
          multiline
        />
      </Grid>

      <Grid size={12}>
        <TextField
          label="Total Audience Size"
          disabled={component === "consumer"}
          formikProps={formikProps}
          name="audience_size"
        />
      </Grid>

      <Grid size={12}>
        <TextField
          disabled={component === "consumer"}
          formikProps={formikProps}
          name="audience_pricing"
          label="Audience Pricing"
        />
      </Grid>
    </Fragment>
  );
}
